import { Pipe, PipeTransform } from "@angular/core";
import { apps } from "../constants/app-constant";
@Pipe({
  name: 'widgetBorderStyle',
  standalone: true
})

export class WidgetBorderStylePipe implements PipeTransform {

  transform(ownerAppId: string): any {
    ownerAppId = ownerAppId.toLowerCase();
    let style = 'border-orange';
    switch (ownerAppId) {
      case apps.amSuite.toLowerCase():
      case apps.employeeArchive.toLowerCase():
        return style;

      case apps.crm.toLowerCase():
      case apps.dialog.toLowerCase():
      case apps.partyProfile.toLowerCase():
        style = 'border-red';
        break;

      case apps.calendar.toLowerCase():
        style = 'border-blue';
        break;

      case apps.attendanceSheet.toLowerCase():
      case apps.causalRequest.toLowerCase():
      case apps.refundedCosts.toLowerCase():
      case apps.clocking.toLowerCase():
        style = 'border-green';
        break;

      default:
        break;
    }

    return style;
  }
}
